import { Component, OnInit } from '@angular/core';
import { EmployeeActivityModel } from '../shared/models/employee-activity-model';
import { NgForm } from '@angular/forms';
import { Employee } from '../shared/models/employee';
import { PpsUtilityService } from '../services/pps-utility.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'pps-employee-activity-form',
  templateUrl: './employee-activity-form.component.html',
  styles: [
  ],
})
export class EmployeeActivityFormComponent implements OnInit {
  formTitle: string;
  activityModel: EmployeeActivityModel = new EmployeeActivityModel();

  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    private util: PpsUtilityService) { }

  ngOnInit(): void {
    this.setInitialData(
      this.dialogConfig.data.employee, 
      this.dialogConfig.data.activity, 
      this.dialogConfig.data.title);
  }

  private setInitialData(employee: Employee, activity: string, title: string){
    this.activityModel.employeeId = employee.id;
    this.activityModel.activity = activity;
    this.activityModel.activityDate = new Date();
    this.formTitle = `${title} - ${this.util.getEmployeeName(employee)}`;
  }

  save(form: NgForm){
    if (form.invalid){
      return false;
    }

    this.dialogRef.close(this.activityModel);
  }

  cancel(){
    this.dialogRef.close();
  }
}
